import '../../styles/globals.css'
import { initViewport } from '../../utils/viewport'
import { Game } from './Game'
import { FruitType } from './FruitTypes'

// Init viewport height detection for mobile
initViewport()

// DOM Elements
const canvas = document.getElementById('game-canvas') as HTMLCanvasElement
const scoreElement = document.getElementById('score') as HTMLSpanElement
const nextFruitPreview = document.getElementById('next-fruit-preview') as HTMLDivElement
const gameOverOverlay = document.getElementById('game-over-overlay') as HTMLDivElement
const finalScoreElement = document.getElementById('final-score') as HTMLSpanElement
const restartButton = document.getElementById('restart-button') as HTMLButtonElement

// Initialize game
let game: Game | null = null

function updateScore(score: number): void {
  scoreElement.textContent = score.toString()
}

function updateNextFruit(fruit: FruitType): void {
  nextFruitPreview.textContent = fruit.emoji
  nextFruitPreview.style.fontSize = `${Math.min(40, fruit.radius * 1.2)}px`
  nextFruitPreview.style.backgroundColor = 'transparent'
  nextFruitPreview.style.borderColor = 'rgba(255, 255, 255, 0.2)'
}

function showGameOver(finalScore: number): void {
  finalScoreElement.textContent = finalScore.toString()
  gameOverOverlay.classList.remove('hidden')
}

function hideGameOver(): void {
  gameOverOverlay.classList.add('hidden')
}

function initGame(): void {
  if (game) {
    game.stop()
  }

  game = new Game({
    canvas,
    onScoreChange: updateScore,
    onNextFruitChange: updateNextFruit,
    onGameOver: showGameOver,
  })

  game.start()
}

// Event listeners
restartButton.addEventListener('click', () => {
  hideGameOver()
  if (game) {
    game.restart()
  }
})

// Resize the game whenever the canvas box changes — covers window resizes,
// mobile browser-bar collapse/expand, and viewport.ts's inline height updates
const resizeObserver = new ResizeObserver(() => {
  if (game) {
    game.resize()
  }
})
resizeObserver.observe(canvas)

// Start the game
initGame()
